import React, { useState, useEffect, useCallback } from "react";
import dayjs from "dayjs";
import { NavLink, useNavigate } from "react-router-dom";
import { useRol } from "../../Context";
import { PageBase } from "../../Components/PageBase";
import { FabButton } from "../../Components/FabButton";
import { getCsrfToken } from '../../utils/csrf';
import "./Equipo.css";
import iconSvg from '../../icons/add-circle.svg';
import ojoMovil from '../../icons/eye-outline2.svg';
import avatarMovil from "../../icons/avatar.png";
import flechas from '../../icons/swap-horizontal.svg';
import flechita from '../../icons/ios-arrow-down.svg';
import securityImg from '../../icons/security.jpg';
import trashIcon from '../../icons/trash.svg';

function Equipo() {

    const navigate = useNavigate();

    const {
        projects,
        vacantCode,
        setSelectedCompanyId,
        selectedCompanyId,
        lengthUser,
        listaUsers,
        fetchUserTeam,
        updateUserTeam,
        dataProfile,
        leads,
        counts,
        dataUser,
        tradeNames,
        rolActivo,
    } = useRol();

    // Modal **WEB** agregar usuarios
    const [isModalOpenAddUser, setIsModalOpenAddUser] = useState(false);
    const openModalAddUser = () => {
        setIsModalOpenAddUser(true);
    };
    const closeModalAddUser = () => {
        setIsModalOpenAddUser(false);
        document.body.style.overflow = 'visible';
    };

    // Modal **MOVIL** agregar usuarios
    const [isModalOpenAddUserMovil, setIsModalOpenAddUserMovil] = useState(false);
    const openModalAddUserMovil = () => {
        setIsModalOpenAddUserMovil(true);
    };
    const closeModalAddUserMovil = () => {
        setIsModalOpenAddUserMovil(false);
        document.body.style.overflow = 'visible';
    };

    useEffect(() => {
        const projectFound = projects?.find(company => company.projects.some(project => project.vacant_code === vacantCode));
        if (projectFound) {
            setSelectedCompanyId(projectFound.id);
        }
    }, [projects, vacantCode, setSelectedCompanyId]);

    const [searchTerm, setSearchTerm] = useState('');
    const [periodoEquipo, setPeriodoEquipo] = useState('mes');

    // Panel de usuario
    const [panelOpen, setPanelOpen] = useState(false);
    const [panelTab, setPanelTab] = useState('perfil');
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [rol, setRol] = useState('');

    useEffect(() => {
        if (dataUser) {
            setUsername(dataUser.username || '');
            setEmail(dataUser.email || '');
            setFirstName(dataUser.first_name || '');
            setLastName(dataUser.last_name || '');
            setRol(dataUser.rol || 'Asesor');
        }
    }, [dataUser]);

    const [updateStatus, setUpdateStatus] = useState(null);
    const [newPwd, setNewPwd] = useState('');
    const [confirmPwd, setConfirmPwd] = useState('');
    const [changePwdStatus, setChangePwdStatus] = useState(null);

    const openUserPanel = (userId) => {
        fetchUserTeam(userId);
        setPanelTab('perfil');
        setPanelOpen(true);
        setUpdateStatus(null);
    };

    const closeUserPanel = () => setPanelOpen(false);

    const handleUpdateUser = async () => {
        if (!dataUser?.id) return;
        const result = await updateUserTeam(dataUser.id, {
            email,
            first_name: firstName,
            last_name: lastName,
            rol,
        });
        setUpdateStatus(result.success ? 'ok' : 'error');
        setTimeout(() => setUpdateStatus(null), 3000);
    };

    const handleChangePassword = async () => {
        if (!newPwd || !confirmPwd) {
            setChangePwdStatus('empty');
            setTimeout(() => setChangePwdStatus(null), 3000);
            return;
        }
        if (newPwd !== confirmPwd) {
            setChangePwdStatus('mismatch');
            setTimeout(() => setChangePwdStatus(null), 3000);
            return;
        }
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL || ''}/api/accounts/${dataUser.id}`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': getCsrfToken(),
                },
                credentials: 'include',
                body: JSON.stringify({ new_password: newPwd }),
            });
            if (response.ok) {
                setChangePwdStatus('ok');
                setNewPwd('');
                setConfirmPwd('');
                setTimeout(() => setChangePwdStatus(null), 3000);
            } else {
                setChangePwdStatus('error');
                setTimeout(() => setChangePwdStatus(null), 3000);
            }
        } catch (error) {
            console.error('Error al cambiar contraseña:', error);
            setChangePwdStatus('error');
            setTimeout(() => setChangePwdStatus(null), 3000);
        }
    };

    const handleDeleteUser = async () => {
        if (!dataUser?.id) return;
        const confirmed = window.confirm(`¿Eliminar a ${dataUser.first_name} ${dataUser.last_name}? Esta acción no se puede deshacer.`);
        if (!confirmed) return;
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL || ''}/api/accounts/${dataUser.id}`, {
                method: 'DELETE',
                headers: { 'X-CSRFToken': getCsrfToken() },
                credentials: 'include',
            });
            if (response.ok) {
                window.location.reload();
            }
        } catch (error) {
            console.error('Error al eliminar usuario:', error);
        }
    };

    const handleSearch = useCallback((event) => {
        setSearchTerm(event.target.value);
    }, []);

    const filterLeadsByPeriodo = (leadsArr, periodo) => {
        if (periodo === 'todos' || !Array.isArray(leadsArr)) return leadsArr;
        const now = new Date();
        if (periodo === '90dias') {
            const cutoff = new Date();
            cutoff.setDate(cutoff.getDate() - 90);
            return leadsArr.filter(l => new Date(l.review_date) >= cutoff);
        }
        if (periodo === 'mes') {
            return leadsArr.filter(l => {
                const d = new Date(l.review_date);
                return d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear();
            });
        }
        return leadsArr;
    };

    const cardCounts = (() => {
        if (!Array.isArray(leads)) return periodoEquipo === 'todos' ? counts : null;
        const filtered = filterLeadsByPeriodo(leads, periodoEquipo);
        return {
            total: filtered.length,
            potenciales: filtered.filter(l => l.contracting_status === 'Potencial').length,
            cierre: filtered.filter(l => l.contracting_status === 'Cierre').length,
            congelados: filtered.filter(l => {
                const diffDays = (new Date(l.review_date) - new Date()) / 86400000;
                return diffDays < -22 && l.contracting_status !== 'Cierre';
            }).length,
        };
    })();

    const [sortOrder, setSortOrder] = useState('asc');
    const [sortColumn, setSortColumn] = useState(null);
    const [copied, setCopied] = useState(null);
    const [activeStates, setActiveStates] = useState({});

    useEffect(() => {
        if (listaUsers) {
            const initial = {};
            listaUsers.forEach(u => { initial[u.id] = u.is_active; });
            setActiveStates(initial);
        }
    }, [listaUsers]);

    const handleToggleActive = async (userId, newValue) => {
        setActiveStates(prev => ({ ...prev, [userId]: newValue }));
        await updateUserTeam(userId, { is_active: newValue });
    };

    // Agregar usuario form state
    const [newFirstName, setNewFirstName] = useState('');
    const [newLastName, setNewLastName] = useState('');
    const [newEmail, setNewEmail] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [newRol, setNewRol] = useState('Asesor');
    const [addUserStatus, setAddUserStatus] = useState(null);

    const handleAddUser = async () => {
        if (!newFirstName || !newEmail || !newPassword) {
            setAddUserStatus('missing');
            setTimeout(() => setAddUserStatus(null), 3000);
            return;
        }
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL || ''}/api/accounts`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': getCsrfToken(),
                },
                credentials: 'include',
                body: JSON.stringify({
                    first_name: newFirstName,
                    last_name: newLastName,
                    email: newEmail,
                    password: newPassword,
                    role: newRol,
                    company_id: selectedCompanyId,
                }),
            });
            if (response.ok) {
                setAddUserStatus('ok');
                setTimeout(() => {
                    setAddUserStatus(null);
                    closeModalAddUser();
                    window.location.reload();
                }, 1500);
            } else {
                setAddUserStatus('error');
                setTimeout(() => setAddUserStatus(null), 3000);
            }
        } catch (error) {
            console.error('Error al agregar usuario:', error);
            setAddUserStatus('error');
            setTimeout(() => setAddUserStatus(null), 3000);
        }
    };

    const handleCopy = (text, key) => {
        navigator.clipboard.writeText(text);
        setCopied(key);
        setTimeout(() => setCopied(null), 1500);
    };

    const handleSort = (column) => {
        if (sortColumn === column) {
            setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
        } else {
            setSortColumn(column);
            setSortOrder('asc');
        }
    };

    return (
        <>
            <PageBase />
            <div className="main-content">
                <div className="team-container">
                    <div className="indicadores-coord-wrapper">
                        <div className="indicadores-coord-header">
                            <div className="indicadores-coord-header-text">
                                <label>Gestiona a tu equipo</label>
                                <span>Agrega, edita, y desactiva asesores aquí. También puedes gestionar su contraseña y proyectos disponibles.</span>
                            </div>
                        </div>
                    </div>
                    <div className="porlet-card">
                        <div className="equipo-table-scroll">
                            <table className="equipo-table">
                                <thead>
                                    <tr>
                                        <th className="equipo-thead-btn">
                                            {['Coordinador', 'Administrador'].includes(rolActivo) && (
                                                <button className="add-member-btn" onClick={openModalAddUser}>
                                                    <img src={iconSvg} alt="+" />
                                                    Agregar usuario
                                                </button>
                                            )}
                                        </th>
                                        <th className="equipo-thead-search" colSpan={4}>
                                            <div className="equipo-search-wrapper">
                                                <input
                                                    type="text"
                                                    placeholder="Busca por nombre, correo o usuario"
                                                    value={searchTerm}
                                                    onChange={handleSearch}
                                                />
                                                <svg className="equipo-search-icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                    <circle cx="11" cy="11" r="8"></circle>
                                                    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                                                </svg>
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {listaUsers?.filter((user) =>
                                        !user.is_staff && user.rol !== 'Administrador' &&
                                        `${user.first_name} ${user.last_name}`.toLowerCase().includes(searchTerm.toLowerCase()))
                                        .sort((a, b) => {
                                            const column = sortColumn || 'first_name';
                                            if (sortOrder === 'asc') {
                                                return (a[column] || '').localeCompare(b[column] || '');
                                            } else {
                                                return (b[column] || '').localeCompare(a[column] || '');
                                            }
                                        })
                                        .map((user) => (
                                            <tr key={user.id}>
                                                <td
                                                    className="equipo-nombre-cell"
                                                    onClick={() => openUserPanel(user.id)}
                                                >
                                                    <div className="equipo-asesor-cell">
                                                        <div className="equipo-asesor-avatar">
                                                            {user.first_name?.[0]?.toUpperCase()}{user.last_name?.[0]?.toUpperCase()}
                                                        </div>
                                                        <div className="equipo-asesor-info">
                                                            <label>{user.first_name} {user.last_name}</label>
                                                            <span>{user.is_staff ? 'Administrador' : (user.rol || 'Asesor')}</span>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <button
                                                        className={`equipo-copy-pill${copied === `${user.id}-email` ? ' equipo-copy-pill--copied' : ''}`}
                                                        onClick={() => handleCopy(user.email, `${user.id}-email`)}
                                                    >
                                                        {copied === `${user.id}-email` ? (
                                                            <>
                                                                <span className="equipo-copy-text">Copiado</span>
                                                                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
                                                                    <polyline points="20 6 9 17 4 12"></polyline>
                                                                </svg>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <span className="equipo-copy-text">{user.email}</span>
                                                                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
                                                                    <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                                                                    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                                                                </svg>
                                                            </>
                                                        )}
                                                    </button>
                                                </td>
                                                <td>
                                                    <button
                                                        className={`equipo-copy-pill${copied === `${user.id}-username` ? ' equipo-copy-pill--copied' : ''}`}
                                                        onClick={() => handleCopy(user.username, `${user.id}-username`)}
                                                    >
                                                        {copied === `${user.id}-username` ? (
                                                            <>
                                                                <span className="equipo-copy-text">Copiado</span>
                                                                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
                                                                    <polyline points="20 6 9 17 4 12"></polyline>
                                                                </svg>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <span className="equipo-copy-text">{user.username}</span>
                                                                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
                                                                    <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                                                                    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                                                                </svg>
                                                            </>
                                                        )}
                                                    </button>
                                                </td>
                                                <td>
                                                    {user.date_joined ? (
                                                        <div className="equipo-actividad">
                                                            <span>{dayjs(user.date_joined).format('DD/MM/YYYY - HH:mm')}</span>
                                                            <span className="equipo-actividad-label">Fecha de registro</span>
                                                        </div>
                                                    ) : (
                                                        <span className="equipo-actividad-label">Sin registro</span>
                                                    )}
                                                </td>
                                                <td>
                                                    {['Coordinador', 'Administrador'].includes(rolActivo) && (
                                                        <div className="equipo-switch-cell">
                                                            <span className={`equipo-switch-label${activeStates[user.id] ? '' : ' equipo-switch-label--inactive'}`}>
                                                                {activeStates[user.id] ? 'Activo' : 'Inactivo'}
                                                            </span>
                                                            <label className="equipo-switch">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={!!activeStates[user.id]}
                                                                    onChange={() => handleToggleActive(user.id, !activeStates[user.id])}
                                                                />
                                                                <span className="equipo-switch-slider" />
                                                            </label>
                                                        </div>
                                                    )}
                                                </td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            {panelOpen && <div className="equipo-panel-overlay" onClick={closeUserPanel} />}
            <div className={`equipo-user-panel${panelOpen ? ' equipo-user-panel--open' : ''}`}>
                <div className="equipo-user-panel-header">
                    <div className="equipo-user-panel-avatar">
                        {dataUser?.first_name?.[0]?.toUpperCase()}{dataUser?.last_name?.[0]?.toUpperCase()}
                    </div>
                    <div className="equipo-user-panel-header-info">
                        <label>{dataUser?.first_name} {dataUser?.last_name}</label>
                        <span>{dataUser?.email}</span>
                    </div>
                    <button className="equipo-user-panel-close" onClick={closeUserPanel}>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="18" y1="6" x2="6" y2="18"></line>
                            <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                    </button>
                </div>
                <div className="equipo-user-panel-tabs">
                    <button className={`equipo-user-panel-tab${panelTab === 'perfil' ? ' equipo-user-panel-tab--active' : ''}`} onClick={() => setPanelTab('perfil')}>Perfil</button>
                    {['Coordinador', 'Administrador'].includes(rolActivo) && (
                        <button className={`equipo-user-panel-tab${panelTab === 'contrasena' ? ' equipo-user-panel-tab--active' : ''}`} onClick={() => setPanelTab('contrasena')}>Cambiar contraseña</button>
                    )}
                </div>
                <div className="equipo-user-panel-body">
                    {panelTab === 'perfil' && <>
                        {rolActivo === 'Administrador' && (
                            <button className="btn-delete-lead" onClick={handleDeleteUser} title="Eliminar usuario">
                                <img src={trashIcon} alt="eliminar" />
                                Eliminar usuario
                            </button>
                        )}
                        <div className="equipo-panel-field">
                            <label>Correo</label>
                            <input type="text" value={email} onChange={e => setEmail(e.target.value)} />
                        </div>
                        <div className="equipo-panel-field">
                            <label>Nombre</label>
                            <input type="text" value={firstName} onChange={e => setFirstName(e.target.value)} />
                        </div>
                        <div className="equipo-panel-field">
                            <label>Apellido</label>
                            <input type="text" value={lastName} onChange={e => setLastName(e.target.value)} />
                        </div>
                        <div className="equipo-panel-field">
                            <label>Rol</label>
                            <select value={rol} onChange={e => setRol(e.target.value)} disabled={rolActivo !== 'Administrador'}>
                                <option value="Asesor">Asesor</option>
                                <option value="Supervisor">Supervisor</option>
                                <option value="Coordinador">Coordinador</option>
                            </select>
                        </div>
                        <div className="equipo-panel-field">
                            <label>Empresa</label>
                            <div className="cuadros-empresa-addUser-modal">
                                <div className="cuadro-empresa">
                                    {projects?.map(company => !tradeNames.includes(company.trade_name) && (
                                        <div key={company.id} className="titulo-cuadro-empresa">{company.trade_name}</div>
                                    ))}
                                </div>
                                <div className="container-button-empresa-addUser-modal">
                                    <button><img src={flechas} alt="flechas" /></button>
                                </div>
                                <div className="cuadro-empresa">
                                    {tradeNames.map((name, i) => (
                                        <div key={i} className="titulo-cuadro-empresa">{name}</div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="equipo-panel-actions">
                            <button className="btn-acept-modal" onClick={handleUpdateUser}>Actualizar perfil</button>
                            {updateStatus === 'ok' && <span className="equipo-panel-feedback equipo-panel-feedback--ok">Perfil actualizado correctamente</span>}
                            {updateStatus === 'error' && <span className="equipo-panel-feedback equipo-panel-feedback--error">Error al actualizar el perfil</span>}
                        </div>
                    </>}
                    {panelTab === 'contrasena' && <>
                        <div className="equipo-panel-password">
                            <p>La nueva contraseña debe tener al menos 8 caracteres y no puede ser enteramente numérica.</p>
                            <div className="equipo-panel-field">
                                <label>Contraseña nueva</label>
                                <input type="password" value={newPwd} onChange={e => setNewPwd(e.target.value)} />
                            </div>
                            <div className="equipo-panel-field">
                                <label>Confirmar contraseña nueva</label>
                                <input type="password" value={confirmPwd} onChange={e => setConfirmPwd(e.target.value)} />
                            </div>
                            <div className="equipo-panel-actions">
                                <button className="btn-acept-modal" onClick={handleChangePassword}>Cambiar contraseña</button>
                                {changePwdStatus === 'ok' && <span className="equipo-panel-feedback equipo-panel-feedback--ok">Contraseña actualizada correctamente</span>}
                                {changePwdStatus === 'error' && <span className="equipo-panel-feedback equipo-panel-feedback--error">Error al cambiar la contraseña</span>}
                                {changePwdStatus === 'mismatch' && <span className="equipo-panel-feedback equipo-panel-feedback--error">Las contraseñas no coinciden</span>}
                                {changePwdStatus === 'empty' && <span className="equipo-panel-feedback equipo-panel-feedback--error">Completa ambos campos</span>}
                            </div>
                        </div>
                    </>}
                </div>
            </div>
            <div className="equipo-movil">
                <div className="container-main-movil">
                    <div className="searchbar-project-movil">
                        <input type="search" placeholder="Buscar por nombre" />
                    </div>
                    <div className="card-project-movil">
                        <div className="card-team-avatar-movil">
                            <img src={avatarMovil} alt="" />
                        </div>
                        <div className="card-team-name-movil">
                            <NavLink to={'/Perfil-de-usuario'} className='nav-links-movil'>
                                <label>Jahir</label>
                            </NavLink>
                            <span>Administrador</span>
                        </div>
                        <div className="card-ojo-project-movil">
                            <img src={ojoMovil} alt="ojoMovil" />
                        </div>
                    </div>
                </div>
            </div>
            <FabButton onClick={openModalAddUserMovil} />
            {isModalOpenAddUser && <div className="equipo-panel-overlay" onClick={closeModalAddUser} />}
            <div className={`equipo-user-panel${isModalOpenAddUser ? ' equipo-user-panel--open' : ''}`}>
                <div className="equipo-user-panel-header">
                    <div className="equipo-user-panel-avatar" style={{ fontSize: '20px' }}>+</div>
                    <div className="equipo-user-panel-header-info">
                        <label>Agregar usuario</label>
                        <span>Completa los datos del nuevo miembro</span>
                    </div>
                    <button className="equipo-user-panel-close" onClick={closeModalAddUser}>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="18" y1="6" x2="6" y2="18"></line>
                            <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                    </button>
                </div>
                <div className="equipo-user-panel-body">
                    <div className="equipo-panel-field">
                        <label>Nombre *</label>
                        <input type="text" value={newFirstName} onChange={e => setNewFirstName(e.target.value)} />
                    </div>
                    <div className="equipo-panel-field">
                        <label>Apellido</label>
                        <input type="text" value={newLastName} onChange={e => setNewLastName(e.target.value)} />
                    </div>
                    <div className="equipo-panel-field">
                        <label>Correo *</label>
                        <input type="email" value={newEmail} onChange={e => setNewEmail(e.target.value)} />
                    </div>
                    <div className="equipo-panel-field">
                        <label>Contraseña *</label>
                        <input type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)} />
                    </div>
                    <div className="equipo-panel-field">
                        <label>Rol</label>
                        <select value={newRol} onChange={e => setNewRol(e.target.value)}>
                            <option value="Asesor">Asesor</option>
                            <option value="Supervisor">Supervisor</option>
                            <option value="Coordinador">Coordinador</option>
                        </select>
                    </div>
                    <div className="equipo-panel-actions">
                        <button className="btn-acept-modal" onClick={handleAddUser}>Agregar usuario</button>
                        {addUserStatus === 'ok' && <span className="equipo-panel-feedback equipo-panel-feedback--ok">Usuario creado correctamente</span>}
                        {addUserStatus === 'error' && <span className="equipo-panel-feedback equipo-panel-feedback--error">Error al crear el usuario</span>}
                        {addUserStatus === 'missing' && <span className="equipo-panel-feedback equipo-panel-feedback--error">Nombre, correo y contraseña son obligatorios</span>}
                    </div>
                </div>
            </div>
        </>
    )
}

export { Equipo }